import React from 'react';
import I18N from '@leverege/i18n';
import HistoryListView from "./HistoryListView.js";
import ItemModelInitializer from "../../attributes/ItemsModelInitializer.js";
import DataViewerModelUpdaterCreator from "../DataViewerModelUpdaterCreator.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.dataViewers.history.HistoryListSupportDataViewer');
export default {
  id: 'molten.dataViewer.history.HistoryListSupportDataViewer',
  type: 'molten.HistoryListSupport',
  name: tf('name'),
  editorName: tf('editorName'),
  icon: tfIcon('historyIcon', 'fa fa-history fa-fw'),
  location: 'none',
  matches: {
    type: ['ItemInfoDataViewer', 'GroupDataViewer']
  },
  settingsUpdaters: DataViewerModelUpdaterCreator.create('ItemViewModelUpdater'),
  createSettings: props => {
    return ItemModelInitializer.create(`${props.objectType}.history`, props);
  },
  render: props => {
    return /*#__PURE__*/React.createElement(HistoryListView, props);
  },
  getDefaultCardContentOptions: {
    height: 'auto'
  }
};